import "./LayerModalHeader.css"
import closeImage from "../../../pictures/modal_pictures/2D_editor_icon_close_w_20x20.png"
interface LayerModalHeaderProsp {
  icon: '.png';
  title: string;
  closeAction: () => void
}
const LayerModalHeader = ({ icon, title, closeAction }: LayerModalHeaderProsp) => {
  return (

    <header>
      <img alt="" src={icon}></img>
      <h2>{title}</h2>
      
      <button
        className="close"
        onClick={closeAction}
      >
        <img alt="close" src={closeImage} />
      </button>
    </header>
  )
}

export default LayerModalHeader;